__webpack_require__.p = "/open-source-dashboard/_next/";